<template>
  <div>
    <div class="home-page justify-content-md-center" style="padding:3%;">
      <b-row id="toptab">
        <b-col md="4">
          <b-form-group horizontal>
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Rechercher" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
        </b-col>
        <b-col md="2">
          <b-button
            size="large"
            color="info"
            class="pull-right"
            @click="leadtimeMeanComputing()"
          >
            Calculer le Lead time
          </b-button>
        </b-col>
        <b-col md="2">
          <b-button
            size="large"
            color="info"
            class="pull-right"
            @click="create()"
          >
            Ajouter une carte Kanban
          </b-button>
        </b-col>
      </b-row>
      <b-table
      id="kanban-be-table"
      ref="table"
      :bordered="true"
      :outlined="true"
      :items="kanbanBeData"
      :fields="fields"
      :filter="filter"
      :tbody-tr-class="rowClass"
      :current-page="currentPage"
      :per-page="perPage"
      >
        <template v-slot:cell(card_id)="row">
          <b-badge variant="primary">
            {{row.item.reference}}#{{row.item.card_number}}
          </b-badge>
        </template>
        <template v-slot:cell(descriptif)="row">
          {{row.item.descriptif}} <br><br>
          <b-button size="sm" variant="light" @click="updateDesc(row.item)"><i class="be-icon fa fa-pencil"></i> Modifier</b-button>
        </template>
        <template v-slot:cell(customer)="row">
          {{row.item.customer}} <br>
          {{row.item.contact}}
        </template>
        <template v-slot:cell(command_date)="row">
          {{row.item.command_date | moment('DD-MM-YYYY')}}
        </template>
        <template v-slot:cell(delay_ask)="row">
          {{row.item.delay_ask | moment('DD-MM-YYYY')}}
        </template>
        <template v-slot:cell(proceed_at)="row">
          {{row.item.proceed_at | moment('DD-MM-YYYY')}}
        </template>
        <template v-slot:cell(lead_time)="row">
          {{compute_leadtime(row)}} 
        </template>
        <template v-slot:cell(action)="row">
          <b-dropdown id="dropdown-right" size="lg" right text="Actions" variant="primary" class="m-2">
            <b-dropdown-item 
              @click="save(row.item)"
                href="#"><i class="be-icon fa fa-check" aria-hidden="true"></i>
              Terminer
            </b-dropdown-item>
            <b-dropdown-divider v-if="row.item.command_type == 'Opportunité'"></b-dropdown-divider>
            <b-dropdown-item
              v-if="row.item.command_type == 'Opportunité'"
              @click="create(row)"
              href="#">
              <i class="be-icon fa fa-plus-circle" aria-hidden="true"></i> Version
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              @click="print(row.item)"
              href="#">
              <i class="be-icon fa fa-print" aria-hidden="true"></i> Imprimer
            </b-dropdown-item>
            <b-dropdown-item
              @click="cancel(row.item)"
              href="#">
              <i class="be-icon fas fa-ban"></i>Annuler
            </b-dropdown-item>
            <b-dropdown-divider v-if="row.item.command_type == 'Opportunité'" ></b-dropdown-divider>
            <b-dropdown-item
              v-if="row.item.command_type == 'Opportunité'"
              @click="commandCreation(row.item)"
              href="#">
              <i class="be-icon fa fa-handshake-o" aria-hidden="true"></i> Nouvelle commande</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <b-row>
        <b-col md="5">
        </b-col>
        <b-col md="5">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
        </b-col>
      </b-row>
    </div>
    <AddKanbanBeModal
      @saved="reload"
      ref="add-kanban-be-modal"
    />
    <EndKanbanBeModal
      @saved="reload"
      ref="end-kanban-be-modal"
    />
    <CommandCreationModal
      @saved="reload"
      ref="command-creation-modal"
    />
    <UpdateDescKbBeModal
      @saved="reload"
      ref="desc-kanban-be-modal"
    />
    <PeriodComputeLTModal
      ref="compute-lt-kanban-be-modal"
    />
    <CancelKbBeModal
      @saved="reload"
      ref="cancel-kanban-be-modal"
    />
  </div>
</template>
<script>

import server from '../../api/server.vue'
import AddKanbanBeModal from '../modal/AddKanbanBeModal'
import EndKanbanBeModal from '../modal/EndKanbanBeModal'
import CommandCreationModal from '../modal/CommandCreationModal'
import UpdateDescKbBeModal from '../modal/UpdateDescKbBeModal'
import PeriodComputeLTModal from '../modal/PeriodComputeLTModal'
import CancelKbBeModal from '../modal/CancelKbBeModal.vue'
import moment from 'moment'



export default {
  name: 'kanbanBe',
  components: {
    AddKanbanBeModal, 
    EndKanbanBeModal,
    CommandCreationModal,
    UpdateDescKbBeModal,
    PeriodComputeLTModal,
    CancelKbBeModal,
  },
  data() {
    return {
      currentPage: 1,
      totalRows: 0,
      isBusy: false,
      filter: null,
      actualCtx: '',
      perPage: 20,
      fields: [
        { key: 'card_id', label: 'N° cartes', sortable: true },
        { key: 'command_date', label: 'Date de commande', sortable: true },
        { key: 'plant', label: 'Entreprise'},
        { key: 'case_type', label: 'Affaire' },
        { key: 'command_type', label: 'Type de commande'},
        { key: 'domain' , label : 'Domaine'},
        { key: 'descriptif' , label : 'Descriptif'},
        { key: 'internal_customer' , label : 'Client interne'},
        { key: 'internal_supplier' , label : 'Fournisseur'},
        { key: 'estimated_workload', label: 'Charge estimée', sortable: true },
        { key: 'done_workload', label: 'Charge réelle', sortable: true },
        { key: 'delay_ask' , label : 'Délai'},
        { key: 'proceed_at', label: 'Terminé le', sortable: true },
        { key: 'lead_time', label: 'Lead Time', sortable: true },
        { key: 'action', label: 'Action', sortable: false }
      ],
      kanbanBeData: null
    }
  },
  computed: {},
  methods: {
    create(row) {
      if (row) {
        // this.versionKanban = row.item
        this.$refs['add-kanban-be-modal'].versionKanbanCommerce(row.item)
      }
        this.$refs['add-kanban-be-modal'].showModal()
    },
    save (item) {
      this.$refs['end-kanban-be-modal'].showModal(item)
    },
    updateDesc(item){
      this.$refs['desc-kanban-be-modal'].showModal(item)
    },
    cancel(item){
      this.$refs['cancel-kanban-be-modal'].showModal(item)
    },
    print (item) {
      let params = _.pick(item, ['command_type',
                                 'domain',
                                 'internal_customer',
                                 'internal_supplier',
                                 'estimated_workload',
                                 'descriptif'])
      params['command_date'] = moment(item.command_date).locale('FR').format('Do MMM YY')
      params['delay_ask'] =  moment(item.delay_ask).locale('FR').format('Do MMM YY')
      params['barcode'] = item.reference+'#'+item.card_number
      params['customer'] = item.customer+'  '+item.plant

      server.printKanbanBe([params]).then(res => {
        this.$toasted.success("Carte kanban BE imprimée !")
      }).catch(error => {
        this.$toasted.error(`Erreur d'impression ! ${error}`)
      })
    },
    rowClass(item, type) {
      if (item.cancel_at !== null) {
        return 'table-secondary'
      }
      if (item.estimated_workload && item.done_workload){
        if (item.estimated_workload < item.done_workload) {
          return 'table-warning'
        } else {
          return 'table-success'
        }
      }
    },
    reload () {
      server.getKanbanBe().then(res => {
        this.kanbanBeData = res.data.cards
      })
    },
    compute_leadtime(row){
      let lead_time = 0
      let dayToMilliseconde = 86400000
      if (row.item.proceed_at) {
        var proceed_at = new Date(row.item.proceed_at)
        var command_date = new Date(row.item.command_date)
        lead_time = (proceed_at - command_date)/ dayToMilliseconde
      }
      return lead_time
    },
    commandCreation(item) {
      this.$refs['command-creation-modal'].showModal(item)
    },
    leadtimeMeanComputing() {
      this.$refs['compute-lt-kanban-be-modal'].showModal()
    }
  },
  mounted: function () {
    server.getKanbanBe().then(res => {
      this.totalRows = res.data.cards.length
      this.kanbanBeData = res.data.cards
    })
  }
};
</script>

<style scoped>
.btn {
  margin-bottom: 2px;
}
#aiopage {
  padding: 5%;
}
.page__background {
  background-color: white !important;
}
label {
  text-align: center;
}
.be-icon  {
  color: #1E7E34;
}
</style>



// WEBPACK FOOTER //
// src/components/andon/KanbanBe.vue